/* @flow */
import * as React from "react";
import idx from "idx";
import { connect } from "react-redux";
import Money_, { mapStateToCurrency } from "./Money";

type Props = {
  currency?: {
    internationalSymbol: {
      abbr: string
    }
  },
  value: string | number,
  valueUSD: string | number,
  valueStyle?: any,
  symbolStyle?: any,
  moneyStyle?: any,
  divider?: string
};

const HowMuchInBucks = (props: Props) => {
  const Money = props.moneyStyle || Money_;
  const abbr = idx(props, props => props.currency.internationalSymbol.abbr);

  return (
    <React.Fragment>
      {abbr !== "USD" && (
        <React.Fragment>
          <Money
            as={Money_}
            Value={props.valueStyle}
            Symbol={props.symbolStyle}
            currency={props.currency}
            isTradePage={props.isTradePage}
          >
            {props.value}
          </Money>
          {props.divider || " / "}
        </React.Fragment>
      )}
      <Money
        as={Money_}
        Value={props.valueStyle}
        Symbol={props.symbolStyle}
        currency="USD"
        isTradePage={props.isTradePage}
      >
        {props.valueUSD}
      </Money>
    </React.Fragment>
  );
};

export default connect(mapStateToCurrency)(HowMuchInBucks);



// WEBPACK FOOTER //
// ./src/components/HowMuchInBucks.js